var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInoxRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9996,
    cy: 16.9997,
    r: 16,
    transform: "rotate(-0.502579 16.9996 16.9997)",
    fill: "#234B9E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0515 22.833L22.83 16.9522L16.9492 11.1737L15.2869 12.8655L18.2676 15.7943L11.0005 15.858L11.0215 18.2538L18.2886 18.19L15.3598 21.1707L17.0515 22.833ZM17.1405 32.975C14.9577 32.9941 12.891 32.593 10.9405 31.7715C8.98991 30.9501 7.28289 29.8203 5.81938 28.3823C4.3559 26.9442 3.19638 25.2573 2.34083 23.3214C1.48527 21.3856 1.04792 19.3262 1.02877 17.1435C1.00939 14.934 1.41043 12.8541 2.2319 10.9035C3.05336 8.95298 4.18316 7.25259 5.62131 5.80242C7.05948 4.35225 8.74648 3.19938 10.6823 2.34383C12.6181 1.48827 14.6775 1.05092 16.8603 1.03177C19.0697 1.01239 21.1497 1.41343 23.1002 2.2349C25.0508 3.05636 26.7511 4.17951 28.2012 5.60435C29.6512 7.02918 30.804 8.70956 31.6596 10.6454C32.5151 12.5812 32.9526 14.6538 32.972 16.8633C32.9911 19.046 32.59 21.1128 31.7685 23.0633C30.9471 25.0139 29.824 26.7208 28.3992 28.1842C26.9745 29.6476 25.2942 30.807 23.3584 31.6626C21.4225 32.5181 19.3499 32.9556 17.1405 32.975ZM17.1195 30.5793C20.8994 30.5461 24.0954 29.1937 26.7075 26.5219C29.3196 23.8501 30.6092 20.6376 30.5762 16.8843C30.5431 13.1044 29.1973 9.90828 26.5389 7.29608C23.8804 4.68388 20.6612 3.39436 16.8813 3.42752C13.128 3.46044 9.93858 4.80618 7.31304 7.46472C4.68753 10.1233 3.39136 13.3425 3.42451 17.1225C3.45744 20.8758 4.80983 24.0651 7.48169 26.6905C10.1536 29.316 13.3661 30.6122 17.1195 30.5793Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInoxRight);
export default __webpack_public_path__ + "static/media/inox-right.5acce002f07d118fd49258c3b5758f00.svg";
export { ForwardRef as ReactComponent };